import { isDefined } from "@perxis-auto/shared";
const formatVehicleStatus = (extItem) => {
  const { logisticStatus } = extItem.data;
  if (!isDefined(logisticStatus == null ? void 0 : logisticStatus.displayName)) {
    return null;
  }
  return {
    label: logisticStatus.displayName,
    iconColor: logisticStatus == null ? void 0 : logisticStatus.color
  };
};
export {
  formatVehicleStatus
};
